import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { redirectsApi } from '../../services/api/redirects';

export const Redirect: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const performRedirect = async () => {
      if (!slug) {
        setError('No redirect slug provided');
        setLoading(false);
        return;
      }

      try {
        const redirect = await redirectsApi.getRedirectByInput(slug);
        
        if (redirect && redirect.output) {
          // Set redirecting state before performing redirect
          setRedirecting(true);
          setLoading(false);
          // Small delay to ensure the UI updates
          setTimeout(() => {
            window.location.href = redirect.output;
          }, 100);
        } else {
          setError('Redirect not found');
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching redirect:', err);
        setError('Failed to fetch redirect');
        setLoading(false);
      }
    };

    performRedirect();
  }, [slug]);

  if (loading || redirecting) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        backgroundColor: 'var(--color-background)',
        color: 'var(--color-text-primary)'
      }}>
        <div className="loading-spinner"></div>
        <p style={{ marginTop: '1rem' }}>Redirecting...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        textAlign: 'center',
        padding: '2rem',
        backgroundColor: 'var(--color-background)',
        color: 'var(--color-text-primary)'
      }}>
        <h1>Redirect Not Found</h1>
        <p>{error}</p>
        <a href="/" style={{ marginTop: '1rem', color: 'var(--color-primary)' }}>Go to Homepage</a>
      </div>
    );
  }

  // This should never render as we redirect before reaching here
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      backgroundColor: 'var(--color-background)',
      color: 'var(--color-text-primary)'
    }}>
      <p>Redirecting...</p>
    </div>
  );
};